module.exports = __webpack_public_path__ + "static/img/banner.fcd48229.png";